import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { ListNavigationModule, MediaModule, SpinnerModule } from '@spartacus/storefront';
import { KnBrAddToCartModule } from 'src/feature-libs/kn-br-cart/base/components/kn-br-add-to-cart/kn-br-add-to-cart.module';
import { KnBrAddToQuoteModule } from 'src/feature-libs/kn-br-cart/base/components/kn-br-add-to-quote/kn-br-add-to-quote.module';
import { KnBrDirectiveModule } from 'src/shared/directive/kn-br-directive.module';
import { KnBrOrderFormItemComponent } from './kn-br-order-form-item/kn-br-order-form-item.component';
import { KnBrOrderFormSearchResultComponent } from './kn-br-order-form-search-result.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [KnBrOrderFormSearchResultComponent, KnBrOrderFormItemComponent],
  imports: [
    CommonModule,
    I18nModule,
    MediaModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ListNavigationModule,
    KnBrAddToCartModule,
    KnBrAddToQuoteModule,
    SpinnerModule,
    KnBrDirectiveModule,
    RouterModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrOrderFormComponent: {
          component: () =>
            import('./kn-br-order-form-search-result.component').then((c) => c.KnBrOrderFormSearchResultComponent),
        },
      },
    } as CmsConfig),
  ],
})
export class KnBrOrderFormSearchResultModule { }
